<div class="presentation-options-container flex flex-col gap-6 p-3 min-w-[10vw] justify-center items-center text-black">
    <div class="presentation-options-title flex items-center justify-between w-full border-b border-0 border-solid border-b-[2px] border-neptune-color-primary-200 pb-3">
        <div class="text-neptune-default !text-xl !font-normal">Download Presentation</div>
        <img
            src="assets/shared-icons/neptune-icon-black-close.svg"
            class="cursor-pointer h-[36px]"
            (click)="onClose.emit()"
            alt="cancel icon"
        />
    </div>
    @switch (pageView) {
        @case ('Presentation Format') 
        {
            <ng-container [ngTemplateOutlet]="presentationFormatSelection"></ng-container>
        }
        @case ('Template') 
        {
            <ng-container [ngTemplateOutlet]="templateSelection"></ng-container>
        }
        @case ('Language') 
        {
            <ng-container [ngTemplateOutlet]="languageSelection"></ng-container>
        }
    }
</div>

<ng-template #presentationFormatSelection>
    <div class="w-full gap-2 flex items-center">
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue text-white">1</div>
        <div>Presentation Format</div>
        <div class="flex-1 h-px bg-neptune-border-subtle"></div>
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-surface-dark text-white">2</div>
        <div>Template</div>
        <div class="flex-1 h-px bg-neptune-border-subtle"></div>
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-surface-dark text-white">3</div>
        <div>Language</div>
    </div>
    <div>
        This account spans multiple regions. Which region's template would you like to use?
    </div>

    <div class="region-selection-options flex flex-col gap-3 w-full max-h-[60vh] overflow-y-auto pr-2">
        <label
            *ngFor="let regionCode of regionFilters"
            class="selectable-option box-border flex items-center justify-between w-full border cursor-pointer
                border-solid border-sky-blue px-2 py-2"
            [for]="'region-' + regionCode">
            <div class="flex items-center">
                <input
                    [id]="'region-' + regionCode"
                    type="radio"
                    [checked]="isRegionSelected && selectedRegionCode === regionCode"
                    name="regionCode"
                    [value]="regionCode"
                    (change)="onRegionSelection($event)"
                    class="neptune-radio"
                    />
                <span class="text-base">{{regionDisplayNames[regionCode]}}</span>
            </div>
            
            <!-- If multiple templates available for the region -->
            @if (combinedConfig[regionCode].length > 1) {
                <span class="text-xs text-neptune-color-fg-muted">{{combinedConfig[regionCode].length}} templates available</span>
            } @else { <!-- If only one template available for the region, -->
                @if (combinedConfig[regionCode][0].translations.length == 1) {
                    <!-- If only one translation available for the template -->
                    <span  class="text-xs text-neptune-color-fg-muted">{{combinedConfig[regionCode][0].translations[0].name}} only</span>  
                } @else {
                    <!-- If multiple translations available for the template -->
                    <span class="text-xs text-neptune-color-fg-muted">{{combinedConfig[regionCode][0].translations.length}} translations available</span>
                }
            }
        </label>
    </div>

    <div class="action-buttons flex gap-4 items-center justify-between w-full">
        <button class="close-button neptune-button-white" (click)="onClose.emit()">Close</button>
        @if (templateSelectable || languageSelectable) {
            <button  class="proceed-button" [disabled]="!isRegionSelected" [ngClass]="[isRegionSelected ? 'neptune-button-blue': 'neptune-button-disabled']" (click)="continueFromRegionSelection()">Continue</button>
        } @else if (!(templateSelectable || languageSelectable)) {
            <button class="proceed-button"  [disabled]="!isRegionSelected" [ngClass]="[isRegionSelected ? 'neptune-button-blue': 'neptune-button-disabled']" (click)="onProceedWithSelections()">
                <img class="!h-5 !w-5" src="assets/shared-icons/neptune-download-icon.svg" alt="" aria-hidden="true" />
                Proceed with Download
            </button>
        }
    </div>
</ng-template>

<ng-template #templateSelection>
    <div class="w-full gap-2 flex items-center">
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue">
            <img src="assets/shared-icons/neptune-icon-white-tick.svg">
        </div>
        <div>Presentation Format</div>
        <div class="flex-1 h-px bg-neptune-border-subtle"></div>
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue text-white">2</div>
        <div>Template</div>
        <div class="flex-1 h-px bg-neptune-border-subtle"></div>
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-surface-dark text-white">3</div>
        <div>Language</div>
    </div>
    <div>
        Select a {{regionDisplayNames[selectedRegionCode]}} template.
    </div>

    <div class="template-selection-options flex flex-col gap-3 w-full max-h-[60vh] overflow-y-auto pr-2">
        <label
            *ngFor="let template of combinedConfig[selectedRegionCode]"
            class="selectable-option box-border flex items-center justify-between w-full border cursor-pointer
                border-solid border-sky-blue px-2 py-2"
            [for]="'presentationConfig-' + template.presentationConfig.presentationType">
            <div class="flex items-center">
                <input
                    [id]="'presentationConfig-' + template.presentationConfig.presentationType"
                    type="radio"
                    [checked]="selectedTemplateCode === template.presentationConfig.presentationType"
                    name="presentationConfig"
                    [value]="template.presentationConfig.presentationType"
                    (change)="onTemplateSelection($event)"
                    class="neptune-radio"
                    />
                <span class="text-base">{{template.presentationConfig.displayName}}</span>
            </div>
            
            <!-- If multiple languages available for the template -->
            @if (template.translations.length > 1) {
                <span class="text-xs text-neptune-color-fg-muted">{{template.translations.length}} languages available</span>
            } @else if (template.translations.length == 1) {
                <!-- If only one language available for the template -->
                <span class="text-xs text-neptune-color-fg-muted">{{template.translations[0].name}} only</span>
            }       
        </label>
    </div>

    <div class="action-buttons flex gap-4 items-center justify-between w-full">
        @if (presentationFormatSelectable) {
            <button class="close-button neptune-button-white" (click)="pageView='Presentation Format'; selectedTemplateCode=undefined;">Back</button>
        } @else {
            <button class="close-button neptune-button-white" (click)="onClose.emit()">Close</button>
        }

        @if (languageSelectable) {
            <button class="proceed-button" [disabled]="!isTemplateSelected" [ngClass]="[isTemplateSelected ? 'neptune-button-blue': 'neptune-button-disabled']" (click)="pageView='Language'">Continue</button>
        } @else {
            <button class="proceed-button" [disabled]="!isTemplateSelected" [ngClass]="[isTemplateSelected ? 'neptune-button-blue': 'neptune-button-disabled']" (click)="onProceedWithSelections()">
                <img class="!h-5 !w-5" src="assets/shared-icons/neptune-download-icon.svg" alt="" aria-hidden="true" />
                Proceed with Download
            </button>
        }    
    </div>
</ng-template>

<ng-template #languageSelection>
    <div class="w-full gap-2 flex items-center">
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue">
            <img src="assets/shared-icons/neptune-icon-white-tick.svg">
        </div>
        <div>Presentation Format</div>
        <div class="flex-1 h-px bg-neptune-border-subtle"></div>
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue">
            <img src="assets/shared-icons/neptune-icon-white-tick.svg">
        </div>
        <div>Template</div>
        <div class="flex-1 h-px bg-neptune-border-subtle"></div>
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue text-white">3</div>
        <div>Language</div>
    </div>
    <div>
        Select the language for the {{selectedTemplateCode}} deck.
    </div>

    <div class="language-selection-options grid grid-cols-2 gap-3 w-full max-h-[60vh] overflow-y-auto pr-2">
        <label
            *ngFor="let language of translationOptions"
            class="selectable-option box-border flex items-center w-full border cursor-pointer
                border-solid border-sky-blue px-2 py-2"
            [for]="'language-' + language.code">
            <input
                [id]="'language-' + language.code"
                type="radio"
                [checked]="selectedTranslationCode === language.code"
                name="language"
                [value]="language.code"
                (change)="onTranslationSelection($event)"
                class="neptune-radio"
                />
            <div class="flex flex-col">
                <span class="text-base">{{language.name}}</span>
                <span class="text-xs text-neptune-color-fg-muted">{{translationNativeNames[language.code]}}</span>
            </div>
        </label>
    </div>

    <div class="action-buttons flex gap-4 items-center justify-between w-full">
        @if(presentationFormatSelectable || templateSelectable) {
            <button class="close-button neptune-button-white" (click)="navigateBackFromLanguageSelection()">Back</button>
        } @else if (!(presentationFormatSelectable || templateSelectable)) {
            <button class="close-button neptune-button-white" (click)="onClose.emit()">Close</button>
        }
        
        <button class="proceed-button" [disabled]="!isLanguageSelected" [ngClass]="[isLanguageSelected ? 'neptune-button-blue': 'neptune-button-disabled']" (click)="onProceedWithSelections()">
            <img class="!h-5 !w-5" src="assets/shared-icons/neptune-download-icon.svg" alt="" aria-hidden="true" />
            Proceed with Download
        </button>
    </div>
</ng-template>
